import React, { FC } from 'react';
import FilePreview from './FilePreview';
import LinkPreview from './LinkPreview';
import './style.scss';

interface FileUploadPreviewProps {
  title: string;
  url: string;
  name: string;
  isFile: boolean;
}

const FileUploadPreview: FC<FileUploadPreviewProps> = ({ title, url, name, isFile }) => {
  if (isFile) {
    return <FilePreview title={title} url={url} name={name} />;
  }

  return <LinkPreview link={url} />;
};

export default FileUploadPreview;
